<template>
    <label class="uik-checkbox__wrapper uik-checkbox__radio">
        <input
            :value="value"
            :required="required"
            :name="name"
            :checked="radio_value == value"
            :disabled="disabled"
            type="radio"
            class="uik-checkbox__checkbox"
            @input="$emit('input', $event.target.value)"
        />
        <div
            :class="color != '' ? color:''"
            class="uik-checkbox__label">
            {{ label }}
            {{ (required ? '*':'') }}
        </div>
        <p v-if="description != ''" class="uik-checkbox__description">{{ description }}</p>
    </label>
</template>

<script>
export default {
    name: "UikRadio",
    model: {
        prop: "radio_value",
        event: "input"
    },
    props: {
        radio_value: { type: [String, Number, Boolean], default: "" },
        name: { type: String, default: "" },
        label: { type: String, default: "" },
        value: { type: [String, Number, Boolean], default: "" },
        description: { type: String, default: "" },
        required: { type: Boolean, default: false },
        checked: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        color: { type: String, default: "" }
    },
    mounted () {
        if (this.checked) {
            this.$emit("input", this.value)
        }
    }
}
</script>

<style lang="scss">
.uik-checkbox__wrapper.uik-checkbox__radio {
  .uik-checkbox__label {
    &:before,
    &:after {
      content: '';
      display: block;
      border-radius: 100px;
      transition: .2s;
    }
    &:before {
      margin-right: 10px;
      width: 16px;
      height: 16px; // margin-right: 12px;
      /* Radio: */
      background-image: linear-gradient(0deg, #F6F7F9 0%, #FFFFFF 100%);
      border: 1px solid $borderColorDarker;
      box-shadow: 0 1px 1px 0 rgba(22, 29, 37, 0.05), inset 0 2px 0 0 rgba(255, 255, 255, 0.05);
    }
    &:after {
      height: 6px;
      width: 6px;
      background: #FFFFFF;
      position: absolute;
      top: 5px;
      left: 5px;
      opacity: 0;
    }
  }
  .uik-checkbox__checkbox:checked+.uik-checkbox__label {
    &:before {
      background-image: linear-gradient(0deg, #34AA44 0%, $success 100%);
      border: 1px solid #2D9C3C;
      box-shadow: 0 1px 1px 0 rgba(19, 31, 21, 0.10), inset 0 2px 0 0 rgba(255, 255, 255, 0.06);
    }
    &:after {
      opacity: 1;
    }
    @each $name,
    $color in $colors {
      &:global(.#{$name}) {
        &:before {
          background: $color;
          border-color: $color;
        }
      }
    }
  }
  .uik-checkbox__checkbox[disabled]+.uik-checkbox__label {
    &:before {
      background: rgba(#BCBCBC, .25);
    }
  }
}
</style>
